import { AsnDetailUserLpn } from '../../../interfaces/Asn/Asn'
import React, { Fragment, useEffect, useState } from 'react'
import { ApiResponse } from '../../../typings/ApiResponse'
import { getLpnUser } from './Config/api'
import { Status } from '../../../hooks/useFetchState'
import {
  GenericOrderBy,
  GenericTable,
  TableHeaderConfigWithType,
  getNewDirection
} from '../../../components/_EOS/Table'
import { useApi } from '../../../hooks/useApi'
import { usePagination } from '../../../hooks/usePagination'
import { IconButton, Typography } from '@mui/material'
import { StandardPage } from '../../_EOS/StandardPage'
import { UserAutocomplete } from '../../User/UI/UserAutoComplete'
import RotateLeftIcon from '@mui/icons-material/RotateLeft'

interface GridElementLpnProps {
  asnId: number
  selectedUser: string
  setSelectedUser: any
  setLpnsSelected: any
  isErrorSelectedUser?: React.Dispatch<React.SetStateAction<boolean>>
}

export const generateTableHeadersGridLpnUser = () => {
  const headers: TableHeaderConfigWithType<AsnDetailUserLpn>[] = [
    {
      field: 'lpn',
      fieldReplacement: 'lpn',
      title: 'Lpn',
      sortable: true
    },
    {
      field: 'userAlias',
      title: 'Usuario',
      sortable: true
    }
  ]

  return headers
}

export const GridLpn: React.FC<GridElementLpnProps> = ({
  asnId,
  selectedUser,
  setSelectedUser,
  setLpnsSelected,
  isErrorSelectedUser
}) => {
  const [selectedElement, setSelectedElement] = React.useState<number[]>([]) // ids checkbox = asnDetailfId
  const tableHeadersLpn = generateTableHeadersGridLpnUser()
  const { state, callApi } = useApi<ApiResponse<AsnDetailUserLpn>>()
  const pagination = usePagination(5)
  const [orderBy, setOrderBy] = useState<GenericOrderBy<AsnDetailUserLpn>>({
    field: '',
    direction: 'desc'
  })

  const requestListLpnByAsn = (page?: number, pageSize?: number) => {
    callApi(getLpnUser(asnId, page, pageSize, orderBy))
  }

  const handleSorting = ({
    field,
    direction
  }: GenericOrderBy<AsnDetailUserLpn>) => {
    const auxField = field === 'id' ? 'asnId' : field
    if (auxField === orderBy.field) {
      const newDirection = getNewDirection(orderBy.direction)
      setOrderBy((_prev) => ({ field: auxField, direction: newDirection }))
      return
    }

    setOrderBy({ field, direction })
  }

  const handlePaginationChange = (page: number, pageSize: number) => {
    // If the pageSize is different, we should set page 0
    const auxPage = pagination.pageSize !== pageSize ? 0 : page
    setSelectedElement([])
    requestListLpnByAsn(auxPage, pageSize)
    pagination.setPagination(auxPage, pageSize)
  }

  // Metodos Selección grilla
  const handleCheckChange = (id: number, checked: boolean) => {
    if (checked) {
      setSelectedElement((prev) => [...prev, id])
    } else {
      setSelectedElement((prev) => [...prev.filter((el) => el !== id)])
    }
  }

  const handleCheckAllToggle = (selectAll: boolean) => {
    if (selectAll) {
      // Selecciona todos los IDs de las filas actualmente visibles
      const newCheckedElements = state.data?.items.map((item) => item.id) || []
      setSelectedElement(newCheckedElements)
    } else {
      // Limpia la selección
      setSelectedElement([])
    }
  }

  // guarda nombre de usuario seleccionado
  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedUser(event.target.value)
  }

  useEffect(() => {
    requestListLpnByAsn()
  }, [orderBy])

  // guarda string de lpns que se seleccionaron
  useEffect(() => {
    if (state.data?.items !== undefined && state.data?.items.length > 0) {
      const LpnsSelected = state.data.items
        .filter((elemento) => selectedElement.includes(elemento.id))
        .map((elemento) => elemento.lpn)

      setLpnsSelected(LpnsSelected)
    }
  }, [selectedElement])

  useEffect(() => {
    // limpia información en caso que cierre y abra el dialogo mas de una vez.
    // abarcando si presiona el boton cerrar, X o guardar
    setLpnsSelected([])
    setSelectedUser('')
  }, [])

  return (
    <Fragment>
      <StandardPage pageTitle=''>
        <Fragment>
          <UserAutocomplete
            handleChange={handleSearch}
            userAliasValue={selectedUser}
            isError={isErrorSelectedUser}
          />
          <IconButton
            color='primary'
            onClick={() => {
              setSelectedUser('')
            }}
          >
            <RotateLeftIcon />
          </IconButton>
        </Fragment>
        {state.data?.items && (
          <GenericTable<AsnDetailUserLpn>
            headersConfig={tableHeadersLpn}
            IDKey={'id'}
            data={state.data?.items}
            pagination={{
              totalItem: state.data?.totalItems || 0,
              page: pagination.page,
              pageSize: pagination.pageSize
            }}
            onPaginationChange={handlePaginationChange}
            isLoading={state.status === Status.Loading}
            showCheckboxes={true}
            onCheckChange={handleCheckChange}
            checkedElements={selectedElement}
            onSortChange={handleSorting}
            onCheckAll={handleCheckAllToggle}
            orderField={orderBy}
          />
        )}
        {!state.data?.items && <Typography> cargando...</Typography>}
      </StandardPage>
    </Fragment>
  )
}
